import { graphql, useStaticQuery } from 'gatsby';
import type {
  ABTestComponentConfig,
  ABTestPageConfig,
} from '../../netlify/edge-functions/lib/types';
import getABTest from '@/utils/a-b-test/getABTest';
import getABTestComponent from '@/utils/a-b-test/getABTestComponent';

type Page = Queries.GeneralPageTemplateQuery['kontentItemGeneralPage'];

const useABTestComponent = ({
  page,
  processedABTestConfig,
  processedABTestComponentsConfig,
}: {
  page: Page;
  processedABTestConfig: ABTestPageConfig[];
  processedABTestComponentsConfig: ABTestComponentConfig[];
}) => {
  const { allKontentItemComponentABTest } = useStaticQuery<Queries.ComponentABTestQuery>(graphql`
    query ComponentABTest {
      allKontentItemComponentABTest(filter: { preferred_language: { eq: "en" } }) {
        nodes {
          elements {
            name {
              value
            }
            variants {
              value {
                elements {
                  name {
                    value
                  }
                  component_variant {
                    value {
                      __typename
                      ... on kontent_item {
                        system {
                          codename
                          id
                          type
                        }
                        ...ACCORDION
                        ...ARTICLE_POST
                        ...BUILDING_BLOCK_WRAPPER
                        ...CARDS_BLOCK
                        ...CAROUSEL_SECTION
                        ...COLUMN_BLOCK
                        ...COMBO_BLOCK
                        ...COMPARISON_TABLE
                        ...CTA_BLOCK
                        ...EDITIONS_DOWNLOAD_BLOCK
                        ...FOOTER
                        ...FORM_CONTAINER
                        ...HEADER
                        ...HERO_BLOCK_ARTICLE_DETAIL_1
                        ...HERO_BLOCK_ARTICLE_DETAIL_2
                        ...HERO_BLOCK_HOMEPAGE
                        ...HERO_BLOCK_INDEX
                        ...HERO_EMAIL_FORM
                        ...HTML
                        ...IFRAME
                        ...IMAGE_COLUMN_BLOCK
                        ...INDUSTRY_LOGO_BLOCK
                        ...INTERSTITIAL
                        ...JUMP_TO_MENU
                        ...LANGUAGE_GRID_BLOCK
                        ...LANGUAGE_GRID_BLOCK_V2
                        ...LOGIN_SECTION
                        ...LOGO_BLOCK
                        ...MEDIA_CAROUSEL
                        ...MID_PAGE_CTA
                        ...MID_PAGE_FORM_CONTAINER
                        ...N5050_BLOCK
                        ...N5050_CARD_BLOCK
                        ...OPEN_SOURCE_SOLUTIONS
                        ...PRICING_SLIDER_CONTAINER
                        ...PRICING_V2_CONTAINER
                        ...QUOTE_BLOCK
                        ...QUOTE_BLOCK_V2
                        ...RELEASE_DOWNLOAD
                        ...SECONDARY_HERO_BLOCK
                        ...SECONDARY_NAVIGATION
                        ...SECTION_INTRODUCTION
                        ...SINGLE_MEDIA
                        ...STATBAR_BLOCK
                        ...STICKY_SIDEBAR
                        ...TABBED_BLOCK
                        ...TERTIARY_NAVIGATION
                        ...TESTIMONIAL_BLOCK
                        ...TIMELINE_BLOCK
                        ...VULNERABILITY_DISCLOSURE_TABLE
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  const result = getABTest({
    page,
    processedABTestConfig,
  });

  if (result.abTestId) {
    return result;
  }

  return getABTestComponent({
    page,
    processedABTestComponentsConfig,
    allKontentItemComponentABTest: allKontentItemComponentABTest.nodes,
  });
};

export default useABTestComponent;
